import React from 'react';
import {
    Facebook,
    Instagram,
    Linkedin,
    Mail,
    Phone,
    ArrowRight
} from 'lucide-react';

const Footer = () => {
    return (
        <footer className="bg-slate-900 pt-20 pb-10 overflow-hidden relative">
            {/* Background Effects */}
            <div className="absolute top-0 left-1/4 w-[500px] h-[500px] bg-blue-600/10 blur-[120px] rounded-full pointer-events-none"></div>
            <div className="absolute bottom-0 right-1/4 w-[400px] h-[400px] bg-emerald-600/5 blur-[100px] rounded-full pointer-events-none"></div>

            <div className="max-w-7xl mx-auto px-6 relative z-10">
                <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12 lg:gap-8 mb-16">
                    {/* Brand Section */}
                    <div className="flex flex-col gap-6">
                        <div className="flex items-center gap-3">
                            <img
                                src="/new_logo.png"
                                alt="Vetobase AI"
                                className="w-11 h-11 rounded-xl object-contain bg-white/5 p-0.5"
                            />
                            <div className="flex flex-col leading-tight">
                                <span className="text-xl font-black text-white tracking-tight">Vetobase AI</span>
                                <span className="text-[10px] font-semibold text-slate-400 uppercase tracking-widest">SMC Pvt. Ltd.</span>
                            </div>
                        </div>
                        <p className="text-slate-400 leading-relaxed text-sm">
                            Vetobase AI helps businesses automate customer support, sync data across platforms, and scale operations with intelligent AI agents.
                        </p>
                        <div className="flex gap-4">
                            {[
                                { icon: <Facebook className="w-5 h-5" />, href: "#" },
                                { icon: <Instagram className="w-5 h-5" />, href: "#" },
                                { icon: <Linkedin className="w-5 h-5" />, href: "#" }
                            ].map((social, i) => (
                                <a
                                    key={i}
                                    href={social.href}
                                    className="w-10 h-10 rounded-full border border-slate-800 flex items-center justify-center text-slate-400 hover:text-white hover:border-blue-500 hover:bg-blue-500/10 transition-all"
                                >
                                    {social.icon}
                                </a>
                            ))}
                        </div>
                    </div>

                    {/* Quick Links */}
                    <div>
                        <h4 className="text-white font-bold mb-6 flex items-center gap-2">
                            <span className="w-1.5 h-1.5 bg-blue-500 rounded-full"></span>
                            Platform
                        </h4>
                        <ul className="flex flex-col gap-4">
                            {[
                                { label: 'Partners', href: '#partners' },
                                { label: 'Solutions', href: '#solutions' },
                                { label: 'Contact', href: '#contact' },
                            ].map(link => (
                                <li key={link.label}>
                                    <a href={link.href} className="text-slate-400 hover:text-blue-400 text-sm font-medium transition-colors flex items-center gap-2 group">
                                        <ArrowRight className="w-3 h-3 opacity-0 -translate-x-2 group-hover:opacity-100 group-hover:translate-x-0 transition-all" />
                                        {link.label}
                                    </a>
                                </li>
                            ))}
                        </ul>
                    </div>

                    {/* Company */}
                    <div>
                        <h4 className="text-white font-bold mb-6 flex items-center gap-2">
                            <span className="w-1.5 h-1.5 bg-emerald-500 rounded-full"></span>
                            Company
                        </h4>
                        <ul className="flex flex-col gap-3 text-sm text-slate-400">
                            <li className="font-semibold text-slate-300">Vetobase SMC Private Limited</li>
                            <li>Registered in Pakistan</li>
                        </ul>
                    </div>

                    {/* Get in Touch */}
                    <div className="flex flex-col gap-5">
                        <h4 className="text-white font-bold flex items-center gap-2">
                            <span className="w-1.5 h-1.5 bg-purple-500 rounded-full"></span>
                            Get in Touch
                        </h4>
                        <a
                            href="mailto:support@vetobase.com"
                            className="flex items-center gap-3 text-slate-400 hover:text-blue-400 text-sm font-medium transition-colors"
                        >
                            <div className="w-9 h-9 rounded-lg bg-slate-800/60 border border-slate-800 flex items-center justify-center">
                                <Mail className="w-4 h-4" />
                            </div>
                            <span className="break-all">support@vetobase.com</span>
                        </a>
                        <a
                            href="tel:+923124012324"
                            className="flex items-center gap-3 text-slate-400 hover:text-blue-400 text-sm font-medium transition-colors"
                        >
                            <div className="w-9 h-9 rounded-lg bg-slate-800/60 border border-slate-800 flex items-center justify-center">
                                <Phone className="w-4 h-4" />
                            </div>
                            <span>0312 4012324</span>
                        </a>
                    </div>
                </div>

                {/* Bottom Bar */}
                <div className="pt-10 border-t border-slate-800 flex flex-col md:flex-row justify-between items-center gap-6">
                    <p className="text-slate-500 text-xs text-center md:text-left">
                        &copy; {new Date().getFullYear()} Vetobase SMC Private Limited. All rights reserved.
                    </p>
                    <div className="flex gap-6 md:gap-8">
                        <a href="#" className="text-slate-500 hover:text-white text-xs transition-colors">Privacy Policy</a>
                        <a href="#" className="text-slate-500 hover:text-white text-xs transition-colors">Terms of Service</a>
                    </div>
                </div>
            </div>
        </footer>
    );
};

export default Footer;
